import React, { useEffect, useState } from 'react';
import { ref, onValue, update } from 'firebase/database';
import { database } from '../../firebaseConfig';
import { MUTED } from './crmUi';
import AddClientTask from '../../components/AddClientTask';
import TaskKindLabel from '../../components/TaskKindLabel';

// "Add task" on a lead card: creates a personal task (users/{me}/tasks) linked to this lead with
// crmContactId, the same link the re-engage and call-back tasks use. Lists my open tasks for this lead.

export default function LeadTasks({ contact, uid }) {
  const [tasks, setTasks] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!uid || !contact?.id) return undefined;
    return onValue(ref(database, `users/${uid}/tasks`), (snap) => {
      const list = Object.entries(snap.val() || {})
        .filter(([, t]) => t && t.crmContactId === contact.id && t.status === 'pending')
        .map(([id, t]) => ({ id, ...t }))
        .sort((a, b) => String(a.dueDate || '').localeCompare(String(b.dueDate || '')));
      setTasks(list);
    }, () => setTasks([]));
  }, [uid, contact?.id]);

  const name = [contact.firstName, contact.lastName].filter(Boolean).join(' ') || contact.name || 'lead';
  const complete = async (t) => {
    try { await update(ref(database, `users/${uid}/tasks/${t.id}`), { status: 'completed', completedAt: new Date().toISOString(), completedBy: uid, updatedAt: new Date().toISOString() }); }
    catch (e) { setErr(`Could not complete: ${e?.message || 'error'}.`); }
  };

  return (
    <div style={{ margin: '12px 0', padding: 12, border: '1px solid #e5e5e5', borderRadius: 8 }}>
      <div style={{ fontWeight: 700, marginBottom: 8 }}>Tasks for this lead</div>
      {tasks.length === 0 ? <div style={{ fontSize: 13, color: MUTED, marginBottom: 8 }}>No open tasks for you on this lead.</div> : (
        <div style={{ marginBottom: 10 }}>
          {tasks.map((t) => (
            <label key={t.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 14, padding: '4px 0' }}>
              <input type="checkbox" onChange={() => complete(t)} title="Mark complete" />
              <span><TaskKindLabel task={t} /> <strong>{t.title || t.name}</strong> <span style={{ color: MUTED }}>due {t.dueDate}{t.dueTime ? ` ${t.dueTime}` : ''}</span>{t.notes ? <div style={{ fontSize: 12, color: MUTED, whiteSpace: 'pre-wrap' }}>{t.notes}</div> : null}</span>
            </label>
          ))}
        </div>
      )}
      {err && <div role="alert" style={{ color: '#d32f2f', fontWeight: 700 }}>{err}</div>}
      <AddClientTask uid={uid} contactId={contact.id} contactName={name} startOpen hint="Goes on your Tasks list as a Manual task, linked back to this lead." />
    </div>
  );
}
